import { Outlet } from 'react-router-dom';
import { useDocumentTitle } from '@/hooks/use-document-title';

/**
 * Layout radice che avvolge ogni rotta (anche `/sign-in`, fuori da `ProtectedRoute`).
 * Esiste solo per dare a `useDocumentTitle` un punto di montaggio dentro il router:
 * non rende alcuna presentazione.
 */
export function RootLayout() {
	useDocumentTitle();
	return <Outlet />;
}
